<ng-container *ngIf="isLoading; else pageContent">
  <div class="auth-spinner">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="auth-wrap">

    <div class="auth-left">
      <div>
        <a routerLink="/" class="auth-logo-row">
          <img src="assets/images/BeExpert-logo (3).svg" alt="BeExpert" class="auth-logo-img" />
        </a>

        <div class="auth-step-pill">Step 1 of 5 — Create account</div>

        <h1 class="auth-left-h1">Your placement<br>journey starts<br>here.</h1>
        <p class="auth-left-sub">
          Join students who cracked TCS, Infosys, Wipro &amp; more using
          AI-powered prep and personalised roadmaps.
        </p>

        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Company-specific quizzes &amp; mock tests
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          AI mock interviews with instant feedback
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Personalised 14-day placement roadmap
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          1-on-1 mentor sessions on demand
        </div>

        <div class="auth-co-label">Students preparing for</div>
        <div class="auth-co-row">
          <span class="auth-co-pill tcs-c">TCS</span>
          <span class="auth-co-pill inf-c">Infosys</span>
          <span class="auth-co-pill wip-c">Wipro</span>
          <span class="auth-co-pill acc-c">Accenture</span>
          <span class="auth-co-pill cap-c">Capgemini</span>
        </div>
      </div>

      <div class="auth-stats-bar">
        <div class="auth-stat-col">
          <span class="auth-stat-num">10K+</span>
          <span class="auth-stat-lbl">Active students</span>
        </div>
        <div class="auth-stat-col">
          <span class="auth-stat-num">Free</span>
          <span class="auth-stat-lbl">To get started</span>
        </div>
        <div class="auth-stat-col">
          <span class="auth-stat-num">5 min</span>
          <span class="auth-stat-lbl">To your score</span>
        </div>
      </div>
    </div>

    <div class="auth-right">
      <a routerLink="/" class="auth-mobile-bar">
        <img src="assets/images/beExpert.svg" alt="BeExpert"/>
        <span class="mt-1 beexpert">BeExpert</span>
      </a>
      <div class="auth-form-box">

        <div class="auth-form-title">Create your account</div>
        <div class="auth-form-sub">Free forever. No credit card required.</div>

        <form [formGroup]="signUpForm" (ngSubmit)="onSignUp()">

          <div class="auth-field-row">
            <div class="auth-field">
              <label class="auth-label">First name</label>
              <input
                type="text"
                class="auth-text-input"
                placeholder="first name"
                formControlName="first_name"
              />
              <small class="auth-error"
                *ngIf="signUpForm.get('first_name')?.invalid &&
                       (signUpForm.get('first_name')?.touched || signUpForm.get('first_name')?.dirty)">
                <div *ngIf="signUpForm.get('first_name')?.errors?.['required']">First name is required</div>
                <div *ngIf="signUpForm.get('first_name')?.errors?.['minlength']">Must be at least 2 characters</div>
                <div *ngIf="signUpForm.get('first_name')?.errors?.['maxlength']">Cannot exceed 50 characters</div>
                <div *ngIf="signUpForm.get('first_name')?.errors?.['pattern']">Enter a valid name</div>
              </small>
            </div>

            <div class="auth-field">
              <label class="auth-label">Last name</label>
              <input
                type="text"
                class="auth-text-input"
                placeholder="last name"
                formControlName="last_name"
              />
              <small class="auth-error"
                *ngIf="signUpForm.get('last_name')?.invalid &&
                       (signUpForm.get('last_name')?.touched || signUpForm.get('last_name')?.dirty)">
                <div *ngIf="signUpForm.get('last_name')?.errors?.['minlength']">Must be at least 1 character</div>
                <div *ngIf="signUpForm.get('last_name')?.errors?.['maxlength']">Cannot exceed 50 characters</div>
                <div *ngIf="signUpForm.get('last_name')?.errors?.['pattern']">Enter a valid name</div>
              </small>
            </div>
          </div>

          <div class="auth-field">
            <label class="auth-label">Email <span class="text-danger">*</span></label>
            <input type="email" class="auth-text-input" placeholder="email address" formControlName="email" />
            <small class="auth-error" *ngIf="signUpForm.get('email')?.invalid &&
                     (signUpForm.get('email')?.touched || signUpForm.get('email')?.dirty)">
              <span *ngIf="signUpForm.get('email')?.errors?.['required']">Email is required</span>
              <span  *ngIf="!signUpForm.get('email')?.errors?.['required'] && signUpForm.get('email')?.errors?.['maxlength']">Email cannot exceed 255 characters</span>
              <span *ngIf="!signUpForm.get('email')?.errors?.['required'] && !signUpForm.get('email')?.errors?.['maxlength'] && signUpForm.get('email')?.errors?.['email']">Enter a valid email address</span>
            </small>
          </div>

          <div class="auth-field">
            <label class="auth-label">College / University Name <span class="text-danger">*</span></label>
            <app-college-autocomplete class="registration-college-ac" [control]="collegeNameControl" [minSearchLength]="5"
              (collegeSelected)="selectInstitution($event)" (selectionCleared)="onCollegeSelectionCleared()"
              (cantFind)="onCantFindCollege()">
              <input type="text" class="auth-text-input" placeholder="Search your college/university..." formControlName="college_name" autocomplete="off" />
              <small class="auth-error" *ngIf="signUpForm.get('college_name')?.invalid &&
                       (signUpForm.get('college_name')?.touched || signUpForm.get('college_name')?.dirty)">
                <div *ngIf="signUpForm.get('college_name')?.errors?.['required']">College/University name is required</div>
                <div *ngIf="signUpForm.get('college_name')?.errors?.['maxlength']">Cannot exceed 255 characters</div>
              </small>
              <small class="auth-error" *ngIf="signUpForm.get('college_name')?.valid && !selectedInstitutionId &&
                       (signUpForm.get('college_name')?.touched || signUpForm.get('college_name')?.dirty)">
                <div>Type at least 5 characters and select your college from the list, or use "Can't find your college?" to add it.</div>
              </small>
            </app-college-autocomplete>
          </div>

          <div class="auth-field-row">
            <div class="auth-field">
              <label class="auth-label">Course / Degree <span class="text-danger">*</span></label>
              <select class="auth-text-input" formControlName="course" style="appearance: auto;">
                <option value="" disabled selected>Select course...</option>
                <option *ngFor="let c of coursesList" [value]="c">{{ c }}</option>
              </select>
              <small class="auth-error"
                *ngIf="signUpForm.get('course')?.invalid && (signUpForm.get('course')?.touched || signUpForm.get('course')?.dirty)">
                <div *ngIf="signUpForm.get('course')?.errors?.['required']">Course is required</div>
              </small>
            </div>

            <div class="auth-field">
              <label class="auth-label">Year of Passing <span class="text-danger">*</span></label>
              <select class="auth-text-input" formControlName="year_of_passing" style="appearance: auto;">
                <option *ngFor="let y of passingYears" [ngValue]="y">{{ y }}</option>
              </select>
              <small class="auth-error"
                *ngIf="signUpForm.get('year_of_passing')?.invalid && (signUpForm.get('year_of_passing')?.touched || signUpForm.get('year_of_passing')?.dirty)">
                <div *ngIf="signUpForm.get('year_of_passing')?.errors?.['required']">Year of passing is required</div>
              </small>
            </div>
          </div>

          <div class="auth-field">
            <label class="auth-label">City</label>
            <input type="text" class="auth-text-input" placeholder="city" formControlName="city" />
            <small class="auth-error" *ngIf="signUpForm.get('city')?.invalid &&
                     (signUpForm.get('city')?.touched || signUpForm.get('city')?.dirty)">
              <div *ngIf="signUpForm.get('city')?.errors?.['minlength']">City must be at least 2
                characters</div>
              <div *ngIf="signUpForm.get('city')?.errors?.['maxlength']">City cannot exceed 50
                characters</div>
              <div *ngIf="signUpForm.get('city')?.errors?.['pattern']">Enter a valid city name (letters
                only)</div>
            </small>
          </div>

          <div class="auth-field">
            <label class="auth-label">Password <span class="text-danger">*</span></label>
            <div class="auth-input-wrap">
              <span class="auth-icon-prefix"><i class="bi bi-lock"></i></span>
              <input [type]="showPassword ? 'text' : 'password'" class="auth-icon-input" placeholder="Create a password" formControlName="password" />
              <i [class]="showPassword ? 'bi bi-eye' : 'bi bi-eye-slash'" 
                 (mouseenter)="showPassword = true" 
                 (mouseleave)="showPassword = false" 
                 style="position: absolute; right: 15px; top: 50%; transform: translateY(-50%); cursor: pointer; color: #6c757d; font-size: 1.2rem;"></i>
            </div>
            <small class="auth-error" *ngIf="signUpForm.get('password')?.invalid && (signUpForm.get('password')?.touched || signUpForm.get('password')?.dirty)">
              <ng-container *ngIf="signUpForm.get('password')?.hasError('required'); else checkMinLength">
                <div>Password is required</div>
              </ng-container>
              <ng-template #checkMinLength>
                <ng-container *ngIf="signUpForm.get('password')?.hasError('minlength'); else checkMaxLength">
                  <div>Password must be at least 8 characters</div>
                </ng-container>
              </ng-template>
              <ng-template #checkMaxLength>
                <ng-container *ngIf="signUpForm.get('password')?.hasError('maxlength'); else checkStrength">
                  <div>Password cannot exceed 32 characters</div>
                </ng-container>
              </ng-template>
              <ng-template #checkStrength>
                <ng-container *ngIf="signUpForm.get('password')?.errors?.['passwordStrength'] as strengthErrors">
                  <ng-container *ngIf="!strengthErrors.hasNoSpaces; else checkUpper"><div>Must not contain spaces</div></ng-container>
                  <ng-template #checkUpper><ng-container *ngIf="!strengthErrors.hasUpperCase; else checkLower"><div>Must contain at least one uppercase letter (A-Z)</div></ng-container></ng-template>
                  <ng-template #checkLower><ng-container *ngIf="!strengthErrors.hasLowerCase; else checkNum"><div>Must contain at least one lowercase letter (a-z)</div></ng-container></ng-template>
                  <ng-template #checkNum><ng-container *ngIf="!strengthErrors.hasNumeric; else checkSpecial"><div>Must contain at least one number (0-9)</div></ng-container></ng-template>
                  <ng-template #checkSpecial><ng-container *ngIf="!strengthErrors.hasSpecialChar; else checkWeak"><div>Must contain at least one special character</div></ng-container></ng-template>
                  <ng-template #checkWeak><ng-container *ngIf="!strengthErrors.isNotWeak"><div>Password is too weak/common</div></ng-container></ng-template>
                </ng-container>
              </ng-template>
            </small>
            <small class="auth-error" *ngIf="signUpForm.get('password')?.valid && (signUpForm.errors?.['passwordIsEmail'] || signUpForm.errors?.['passwordIsName']) && (signUpForm.get('password')?.touched || signUpForm.get('password')?.dirty)">
              <div *ngIf="signUpForm.errors?.['passwordIsEmail']">Password cannot be the same as your email</div>
              <div *ngIf="!signUpForm.errors?.['passwordIsEmail'] && signUpForm.errors?.['passwordIsName']">Password cannot be the same as your name</div>
            </small>
          </div>

          <div class="auth-field">
            <label class="auth-label">Confirm Password <span class="text-danger">*</span></label>
            <div class="auth-input-wrap">
              <span class="auth-icon-prefix"><i class="bi bi-lock"></i></span>
              <input [type]="showConfirmPassword ? 'text' : 'password'" class="auth-icon-input" placeholder="Confirm password" formControlName="confirm_password" />
              <i [class]="showConfirmPassword ? 'bi bi-eye' : 'bi bi-eye-slash'" 
                 (mouseenter)="showConfirmPassword = true" 
                 (mouseleave)="showConfirmPassword = false" 
                 style="position: absolute; right: 15px; top: 50%; transform: translateY(-50%); cursor: pointer; color: #6c757d; font-size: 1.2rem;"></i>
            </div>
            <small class="auth-error" *ngIf="(signUpForm.get('confirm_password')?.invalid || signUpForm.hasError('passwordMismatch')) &&
                     (signUpForm.get('confirm_password')?.touched || signUpForm.get('confirm_password')?.dirty)">
              <div *ngIf="signUpForm.get('confirm_password')?.errors?.['required']">Confirm password is required</div>
              <div *ngIf="signUpForm.hasError('passwordMismatch') && !signUpForm.get('confirm_password')?.errors?.['required']">Passwords do not match</div>
            </small>
          </div>

          <div class="auth-field">
            <label class="auth-label">Mobile number <span class="text-danger">*</span></label>
            <div class="auth-phone-wrap">
              <span class="auth-prefix">🇮🇳 +91</span>
              <input
                type="tel"
                class="auth-phone-input"
                placeholder="Enter 10-digit number"
                formControlName="phone_num"
                maxlength="10"
                inputmode="numeric"
                (input)="onPhoneInput($event)"
              />
            </div>
            <small class="auth-error"
              *ngIf="signUpForm.get('phone_num')?.invalid &&
                     (signUpForm.get('phone_num')?.touched || signUpForm.get('phone_num')?.dirty)">
              <div *ngIf="signUpForm.get('phone_num')?.errors?.['required']">Phone number is required</div>
              <div *ngIf="signUpForm.get('phone_num')?.errors?.['pattern']">Enter a valid 10-digit mobile number</div>
              <div *ngIf="signUpForm.get('phone_num')?.errors?.['nonNumeric']">Only numbers are allowed</div>
            </small>
          </div>

          <div class="sms-note">
            <div class="sms-note-icon"><i class="bi bi-telephone"></i></div>
            <div class="sms-note-text">
              A <strong>one-time OTP</strong> will be sent to your mobile via <strong>SMS</strong>.
              We'll send placement updates via WhatsApp once you're in.
            </div>
          </div>

          <button
            type="submit"
            class="auth-submit"
            [disabled]="signUpForm.invalid || !selectedInstitutionId"
          >
            Send OTP →
          </button>

        </form>

        <div class="auth-footer-link">
          Already have an account? <a routerLink="/login" [queryParams]="{ redirectUrl: redirectUrl }">Sign in</a>
        </div>
      </div>
    </div>

  </div>
</ng-template>
